import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { faqs } from '../mock';

const FAQ = () => {
  return (
    <section className="relative py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <div className="section-label mb-6">FAQ</div>
        <h2 className="font-display text-3xl md:text-5xl font-semibold text-white tracking-tight leading-tight mb-12">
          Answered questions
        </h2>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((f) => (
            <AccordionItem key={f.q} value={`item-${f.q}`} className="card-dark rounded-2xl px-6 border !border-white/10">
              <AccordionTrigger className="text-left text-white hover:no-underline hover:text-amber-300 py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-400 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
